import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('boundarySelectPanelField');

    return {
        NO_BOUNDARIES_FOUND: t('noBoundariesFound'),
        SEARCH: t('search')
    };
};

export default useTranslation;
